import React from "react";

import { TextField, Typography, Button, Box, Card, Grid } from "@mui/material";
import * as Yup from "yup";
import "../../../Myaccount/Myaccount.css";
import Divider from "@mui/material/Divider";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

export default function ProjectEvaluationSection3(props) {
  const { t } = useTranslation();
  const styles = (theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },

    cssLabel: {
      color: "yellow",
    },

    cssOutlinedInput: {
      "&$cssFocused $notchedOutline": {
        borderColor: `${theme.palette.primary.main} !important`,
      },
    },

    cssFocused: {},

    notchedOutline: {
      borderWidth: "1px",
      borderColor: "yellow !important",
    },
  });
  const [selectedValue, setSelectedValue] = React.useState();
  const Radiobuttonchange = (event) => {
    setSelectedValue(event.target.value);
  };
  return (
    <>
      <Card sx={{ paddingTop: "10px", paddingBottom: "12px" }}>
        <label className="personal-info-heading">
          <b>{t("ProjectEvalution.Section3")}</b>
        </label>
        <Divider
          sx={{
            marginTop: 2,
            marginBottom: 2,
            backgroundColor: "#667085;",
            height: "1px",
          }}
        />
        {/* first section */}
        {props?.data?.map((r, index) => (
          <div key={index} >
            <div style={{ padding: "10px" }} hidden={!r?.sectionHeader}>
              <Grid sx={{ padding: "12px", backgroundColor: "#F9FAFB", color: "#667085" }}>
                {r.sectionHeader}
              </Grid>
            </div>
            <div className="row mt-2" hidden={!r.hasQuestion}>
              <div className="col-sm-5 col-md-5 col-xl-5 mt-4">
                <span className="input-label-right" >{r.questionText}</span>
              </div>
              <div className="col-sm-4 col-md-4 col-xl-4 mt-3 ">
                <FormControl className="mb-5">
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    hidden={!r?.options}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio checked={r.answers === "1"}
                        onChange={Radiobuttonchange}
                        value={r.answers} />}
                      label="yes"
                      disabled
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio checked={r.answers === "0"}
                        onChange={Radiobuttonchange}
                        value={r.answers} />}
                      label="no"
                      disabled
                    />
                  </RadioGroup>
                </FormControl>
                <TextareaAutosize
                  maxRows={4}
                  aria-label="maximum height"
                  //placeholder="Maximum 4 rows"
                  color="secondary"
                  style={{ width: "300px", height: "128px" }}
                  value={r.answers}
                  disabled
                  hidden={r.options}
                />
              </div>
              <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
            </div>

          </div>
        ))}


      </Card>

    </>
  );
}
